<template>

    <div>

        <b-card>

            <b-row>

                <b-col sm="6" md="4" class="d-flex align-items-center justify-content-between my-1">

                    <date-picker
                        v-model="start_date"
                        placeholder="Start Date"
                        class="f-1">
                    </date-picker> &nbsp;to&nbsp;
                    <date-picker
                        v-model="end_date"
                        placeholder="End Date"
                        class="f-1">
                    </date-picker>
                </b-col>
                <b-col sm="6" md="4" class="my-1">

                    <user-role-search-dropdown type="provider" v-model=" caregiver_id "></user-role-search-dropdown>
                </b-col>
                <b-col sm="6" md="4" class="my-1">

                    <user-role-search-dropdown type="claimant" v-model=" client_id "></user-role-search-dropdown>
                </b-col>
                <b-col sm="6" md="4" class="my-1">

                    <b-form-select v-model="flag_filter" class="mr-1 mb-1">

                        <option value="any">Any Flags</option>
                        <option value="none">No Flags</option>
                        <option value="disputed">Disputed</option>
                        <option value="time_excessive">Excessively Long</option>
                        <option value="added">Manually Added</option>
                        <option value="modified">Modified</option>
                        <option value="time_expire">Time Expired</option>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row class="my-2">

                <b-col class="text-right">

                    <b-button @click=" reloadData() " variant="info" class="my-1">Generate Report</b-button>
                </b-col>
            </b-row>
        </b-card>

        <b-row>
            <b-col lg="12">
                <b-card
                    header="Flagged Visits"
                    header-text-variant="white"
                    header-bg-variant="info"
                >
                    <b-row class="mb-2">
                        <b-col sm="12" class="text-right">
                            <!-- <b-btn :href="url + '&export=1'" variant="success"><i class="fa fa-file-excel-o"></i> Export to Excel</b-btn> -->
                            <b-btn @click="printTable()" variant="primary"><i class="fa fa-print" :disabled="loading"></i> Print</b-btn>
                        </b-col>
                    </b-row>

                    <loading-card v-if="loading" />

                    <div class="table-responsive">
                        <b-table bordered striped hover show-empty
                                :fields="fields"
                                :items="shiftHistoryItems"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                class="shift-table"
                                v-if="!loading"
                        >
                            <template v-slot:cell(Day)="data">
                                {{ data.value !== 'Total' ? dayFormat(data.value) : data.value }}
                            </template>
                            <template v-slot:cell(Claimant)="row">
                                <a :href="'/business/clients/' + row.item.client_id">{{ row.item['Claimant'] }}</a>
                            </template>
                            <template v-slot:cell(Provider)="row">
                                <a :href="'/business/caregivers/' + row.item.caregiver_id">{{ row.item.Provider }}</a>
                            </template>
                            <template v-slot:cell(EVV)="data">
                                <span v-if="data.value" style="color: green">
                                    <i class="fa fa-check-square-o"></i>
                                </span>
                                    <span v-else-if="data.value === undefined"></span>
                                    <span v-else style="color: darkred">
                                    <i class="fa fa-times-rectangle-o"></i>
                                </span>
                            </template>
                            <template v-slot:cell(Confirmed)="data">
                                {{ (data.value) ? 'Yes' : (data.value === undefined) ? '' : 'No' }}
                            </template>
                            <template v-slot:cell(flags)="row">
                                <shift-flag-icons :flags="row.item.flags" />
                            </template>
                            <template v-slot:cell(flag_details)="row">
                                <div v-for="flag in row.item.flag_details" :key="flag.id">
                                    <div v-if="flag.flag == 'modified'" class="mb-2">
                                        <strong>Modified: </strong>
                                        <div v-for="(diff, index) in row.item.change_log" :key="index">
                                            <div v-if="diff.changes" class="text-muted">
                                                {{ formatDateTimeFromUTC(diff.date) }}
                                                <span v-if="diff.revisor">by {{ diff.revisor.name }}</span>
                                            </div>
                                            <div v-for="(change, i) in diffMap(diff.changes)" :key="i">
                                                <strong>{{ change[0] }}</strong>: {{ change[1] }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <strong>{{ flagDisplay(flag.flag) }}: </strong>
                                        <span class="text-muted">
                                            {{ formatDateTimeFromUTC(flag.flagged_at) }}
                                            <span v-if="row.item.creator">by {{ row.item.creator.name }}</span>
                                        </span>
                                    </div>
                                </div>
                            </template>
                            <template v-slot:cell(actions)="row">
                                <span v-if="row.item.id">
                                    <b-btn size="sm" :href="'/business/shifts/' + row.item.id" variant="info" v-b-tooltip.hover title="Edit"><i class="fa fa-edit"></i></b-btn>
                                    <b-btn size="sm" @click.stop="details(row.item)" v-b-tooltip.hover title="View"><i class="fa fa-eye"></i></b-btn>
                                    <b-btn size="sm" @click.stop="deleteShift(row.item)" variant="danger" v-b-tooltip.hover title="Delete"><i class="fa fa-times"></i></b-btn>
                                </span>
                            </template>
                        </b-table>
                    </div>
                </b-card>
            </b-col>
        </b-row>

        <!-- Details modal -->
        <business-shift-details-modal :shift="selectedItem" v-model="detailsModal" />
    </div>
</template>

<script>
    import FormatsNumbers from "../mixins/FormatsNumbers";
    import FormatsDates from "../mixins/FormatsDates";
    import BusinessSettings from "../mixins/BusinessSettings";
    import ShiftMap from "./ShiftMap";
    import ShiftDiffs from '../mixins/ShiftDiffs';

    export default {
        components: { ShiftMap },
        mixins: [FormatsDates, FormatsNumbers, BusinessSettings, ShiftDiffs],

        props: {},

        data() {
            return {
                items: {
                    shifts: [],
                },
                start_date: moment().startOf('isoweek').format('MM/DD/YYYY'),
                end_date: moment().startOf('isoweek').add(6, 'days').format('MM/DD/YYYY'),
                caregiver_id: "",
                client_id: "",
                flag_filter: 'any',
                payment_method: "",
                clients: [],
                caregivers: [],
                showSummary: false,
                sortBy: 'Day',
                sortDesc: true,
                detailsModal: false,
                selectedItem: {
                    client: {}
                },
                fields: [
                    { key: 'Day', sortable: true },
                    { key: 'Claimant', sortable: true },
                    { key: 'Provider', sortable: true },
                    { key: 'EVV', sortable: true },
                    { key: 'flag_details', sortable: false },
                    { key: 'Carrier', sortable: true },
                    { key: 'policy_number', label: 'Policy #', sortable: true },
                    { key: 'flags', sortable: false },
                    { key: 'actions', class: 'hidden-print' }
                ],
                loading: false,
            }
        },

        computed: {
            shiftHistoryItems() {
                let items = this.items.shifts;
                items = items.map((item) => {
                    return {
                        'id': item.id,
                        'Day': item.checked_in_time, // filtered in template
                        'client_id': item.client_id,
                        'caregiver_id': item.caregiver_id,
                        'Claimant': item.client_name,
                        'Provider': item.caregiver_name,
                        'EVV': item.EVV,
                        'Carrier': item.carrier,
                        '_rowVariant': (item.disputed) ? 'danger' : null,
                        'flags': item.flags,
                        'flag_details': item.flag_details,
                        'change_log': item.change_log,
                        'creator': item.creator,
                        'policy_number': item.policy_number,
                    }
                });
                return items;
            },

            url() {
                return '/business/reports/shift-flags?start_date=' + this.start_date + '&end_date=' + this.end_date + '&caregiver_id=' + this.caregiver_id + '&client_id=' + this.client_id + '&flag_filter=' + this.flag_filter;
            }
        },

        methods: {
            formatHours(hours) {
                if (! hours) {
                    return '-';
                }
                let minutes = Math.floor((hours * 60) % 60);
                hours = Math.floor(hours);
                return `${hours}h ${minutes}m`;
            },

            reloadData() {
                this.setLocalStorage('sortBy', 'Day');
                this.setLocalStorage('sortDesc', 'false');
                return this.loadData();
            },

            loadData() {
                // Attempt to load local storage information first
                if (typeof(Storage) !== "undefined") {
                    let startDate = this.getLocalStorage('startDate');
                    if (startDate) this.start_date = startDate;
                    let endDate = this.getLocalStorage('endDate');
                    if (endDate) this.end_date = endDate;
                    let filterCaregiverId = this.getLocalStorage('filterCaregiverId');
                    if (filterCaregiverId) this.caregiver_id = filterCaregiverId;
                    let filterClientId = this.getLocalStorage('filterClientId');
                    if (filterClientId) this.client_id = filterClientId;
                    let filterFlag = this.getLocalStorage('filterFlag');
                    if (filterFlag) this.flag_filter = filterFlag;
                    let sortBy = this.getLocalStorage('sortBy');
                    if (sortBy) this.sortBy = sortBy;
                    let sortDesc = this.getLocalStorage('sortDesc');
                    if (sortDesc === false || sortDesc === true) this.sortDesc = sortDesc;
                    let showSummary = this.getLocalStorage('showSummary');
                    if (showSummary === false || showSummary === true) this.showSummary = showSummary;
                }

                this.loading = true;

                axios.get(this.url + '&json=1')
                    .then(response => {
                        if (Array.isArray(response.data)) {
                            this.items.shifts = response.data;
                        }
                        else {
                            this.items.shifts = [];
                        }
                        this.loading = false;
                    });
            },

            dayFormat(date) {
                return moment.utc(date).local().format('ddd MMM D');
            },

            details(item) {
                let component = this;
                axios.get('/business/shifts/' + item.id)
                    .then(function(response) {
                        let shift = response.data;
                        shift.checked_in_time = moment.utc(shift.checked_in_time).local().format('L LT');
                        shift.checked_out_time = shift.checked_out_time ? moment.utc(shift.checked_out_time).local().format('L LT') : 'Pending';
                        component.selectedItem = shift;
                        component.detailsModal = true;
                        console.log(component.selectedItem);
                    })
                    .catch(function(error) {
                        alert('Error loading shift details');
                    });
            },

            deleteShift(item) {
                let message = 'Are you sure you wish to delete the ' + item.Hours + ' hour shift for ' + item.Provider + ' on ' + this.formatDate(item.Day) + '?';
                if (confirm(message)) {
                    let form = new Form();
                    form.submit('delete', '/business/shifts/' + item.id)
                        .then(response => {
                            this.items.shifts = this.items.shifts.filter(function(shift) {
                                return (shift.id !== item.id);
                            });
                        })
                }
            },

            printTable() {
                $(".shift-table").print();
            },

            getLocalStorage(item) {
                let val = localStorage.getItem('flags_report_' + item);
                if (typeof(val) === 'string') {
                    if (val.toLowerCase() === 'null' || val.toLowerCase() === '') return null;
                    if (val.toLowerCase() === 'false') return false;
                    if (val.toLowerCase() === 'true') return true;
                }
                return val;
            },

            setLocalStorage(item, value) {
                if (typeof(Storage) !== "undefined") {
                    localStorage.setItem('flags_report_' + item, value);
                }
            },
        },

        watch: {
            caregiver_id(val) {
                this.setLocalStorage('filterCaregiverId', val);
            },

            client_id(val) {
                this.setLocalStorage('filterClientId', val);
                if (val) this.payment_method = ""; // Set payment method filter back to all if client is selected
            },

            flag_filter(val) {
                this.setLocalStorage('filterFlag', val);
            },

            start_date(val) {
                this.setLocalStorage('startDate', val);
            },

            end_date(val) {
                this.setLocalStorage('endDate', val);
            },

            sortBy(val) {
                this.setLocalStorage('sortBy', val);
            },

            sortDesc(val) {
                this.setLocalStorage('sortDesc', val);
            },

            showSummary(val) {
                this.setLocalStorage('showSummary', JSON.stringify(val));
            },
        }
    }
</script>

<style>
    table {
        font-size: 14px;
    }
    .table-info, .table-info>td, .table-info>th {
        font-weight: bold;
        font-size: 13px;
        background-color: #ecf7f9;
    }
    .table-sm td, 
    .table-sm th {
        padding: 0.2rem 0;
    }
    .signature > svg {
        margin: -25px 0;
        width: 100%;
        height: auto;
        max-width: 400px;
    }
    .shift-map {
        width: 100%;
        height: 200px;
    }
</style>
